import { cn } from "@/lib/cn";
import { severityBadgeClass } from "@/lib/severity";
import type { Severity } from "@/data/alarmRules/engineConstants";
import { VALID_SEVERITIES } from "@/data/alarmRules/engineConstants";

interface Props {
  value: Severity;
  onChange: (next: Severity) => void;
  disabled?: boolean;
}

export function SeverityPicker({ value, onChange, disabled }: Props) {
  return (
    <div className="flex flex-wrap gap-1">
      {VALID_SEVERITIES.map((s) => (
        <button
          key={s}
          type="button"
          disabled={disabled}
          onClick={() => onChange(s)}
          className={cn(
            "px-2 py-1 text-[11px] uppercase tracking-wide rounded border font-semibold transition-colors",
            severityBadgeClass(s),
            value === s
              ? "ring-1 ring-text-faint"
              : "opacity-60 hover:opacity-100",
            disabled && "cursor-not-allowed opacity-40",
          )}
        >
          {s}
        </button>
      ))}
    </div>
  );
}
